import { render, staticRenderFns } from "./page-tags.html?vue&type=template&id=cfa20ca4&"
import script from "./page-tags.ts?vue&type=script&lang=ts&"
export * from "./page-tags.ts?vue&type=script&lang=ts&"
import style0 from "./page-tags.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports